import { render, staticRenderFns } from "./CreatePlanStepTwo.vue?vue&type=template&id=38312fa9&scoped=true"
import script from "./js/create_plan_two.js?vue&type=script&lang=js&external"
export * from "./js/create_plan_two.js?vue&type=script&lang=js&external"
import style0 from "./CreatePlanStepTwo.vue?vue&type=style&index=0&id=38312fa9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38312fa9",
  null
  
)

export default component.exports